import DatepickerRange from '../../../../../components/DatePickers/Range';
import Select from '../../../../../components/Select/Custom';
import Dropdown from '../../../../../components/Dropdown/Default';
import RequestSearchSelect from '../../../../../components/Select/RequestSearchSelect';
import VirtualSelect from '../../../../../components/Select/Virtual';

export const getFields = (statuses, modes, users, endDate, startDate, getUsersList, services, providers, access) => {
  const elements = [
    {
      labelName: 'Date',
      name: 'date',
      id: 'exportDatepickerFrom',
      component: DatepickerRange,
      defStartDate: startDate,
      defEndDate: endDate,
    },
    access?.autocomplete_users && {
      labelName: 'Users',
      name: 'users',
      title: 'Users',
      id: 'users-search',
      onRequestFunc: getUsersList,
      component: RequestSearchSelect,
      data: users,
    },
    {
      labelName: 'Services',
      name: 'services',
      toggleBtnTitle: 'Services',
      component: VirtualSelect,
      data: services,
      showOptionId: true,
      menuWidth: 500,
      selectedOptions: [],
      selectedLimit: 100,
      showLoader: false,
    },
    {
      labelName: 'Status',
      name: 'status',
      title: 'Statuses',
      toolbarClassStr: 'export__empty-dropdown',
      id: 'status-dropdown',
      allSelected: true,
      component: Select,
      data: statuses,
    },
    {
      labelName: 'Providers',
      name: 'providers',
      toggleBtnTitle: 'Providers',
      component: VirtualSelect,
      data: providers,
      showOptionId: false,
      menuWidth: 350,
      selectedOptions: providers.map((item) => item.id),
      selectedLimit: 100,
    },
    {
      labelName: 'Modes',
      name: 'modes',
      id: 'exportModesDropdown',
      simple: true,
      component: Dropdown,
      data: modes,
      buttonId: 'modes-button',
    },
  ];

  return elements.filter(Boolean);
};

export const checkModes = (modes) => {
  const all = {
    id: -1,
    title: 'All',
  };

  const checkAll = modes?.find((item) => item.title.toLowerCase() === 'all');

  let newModes = [];
  if (!checkAll) {
    newModes = [all, ...modes];
    return newModes;
  }

  return modes;
};

export const parseValues = (values, statuses, include, modes, providers, services) => {
  const parsedStatuses = statuses?.filter((el) => values?.status?.includes(el.title)).map((el) => +el.id);
  const findMode = modes.find((item) => item.title === values.modes);

  return {
    from_date: values.date.startDate,
    to_date: values.date.endDate,
    include_statuses: parsedStatuses.length === statuses.length ? -1 : parsedStatuses,
    include_users: values.users.length === 0 ? -1 : values.users.map((item) => item.id),
    include_providers: providers.length === values.providers.length ? -1 : values.providers,
    include_services: services.length === values.services.length || values.services.length === 0 ? -1 : values.services,
    include_modes: findMode ? findMode.id : -1,
    include_columns: include?.map((item) => item.id),
  };
};
